import { render, staticRenderFns } from "./askDiagnosis.vue?vue&type=template&id=3e51dffd&scoped=true&"
import script from "./askDiagnosis.vue?vue&type=script&lang=js&"
export * from "./askDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./askDiagnosis.vue?vue&type=style&index=0&id=3e51dffd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51dffd",
  null
  
)

export default component.exports